/*
Small component for displaying a group's name, image, and some metadata. Useful
for displaying a list of groups, or more generally somewhere you want to
render a link to a group that comes with a little more information than just the
group name.

DESIGN COMMENTARY:
I suspect that the amount of margin around this component will depend on the
visual context in which the group list is displayed. Until we implement more
similar examples, however, both of lists of groups and lists of other things,
I have not taken a position on where the responsibility for the margins should
lie. For now, I chose to name this in a group-list-specific way unless and until
we see the pattern repeated enough to make this a more generic list wrapper.
(Or we see enough variation that we rename this class to be page-specific rather
than general to all groups.)
*/
import "react";
import DotSeparatedElements from "../dot_separated_elements";
import GroupIcon from "../group/group_icon";
import GrPropTypes from "../shared/gr_prop_types";
import RelativeTime from "../time/relative_time";
import { ICON_SIZES } from "../../modules/shape_icon_values";

class GroupListItem extends React.Component {
  render() {
    let groupInfoLine;
    let groupInfoItems = new Array;
    if (this.props.showUnreadPosts) {
      groupInfoItems.push(<a className="groupListItem__newCommentsLink" href={this.props.group.allUnreadPostsUrl}>
                           new posts
                         </a>);
      groupInfoItems.push(<RelativeTime time={this.props.group.lastActiveAt} longFormat={true} />);
    }
    if (this.props.showMemberCount) {
      groupInfoItems.push(
        <span>{this.props.group.membersCount && `${this.props.group.membersCount} members`}</span>
      );
    }
    if (!this.props.showUnreadPosts) {
      groupInfoItems.push(this.renderLastActiveTimestamp());
    }
    if (groupInfoItems.length === 1) {
      groupInfoLine = groupInfoItems[0];
    } else {
      groupInfoLine = <DotSeparatedElements elements={groupInfoItems} />;
    }

    return (
      <div className="groupListItem objectLockupContent">
        <div className="objectLockupContent__media">
          <GroupIcon group={this.props.group} includeLink={true} size={this.props.iconSize} />
        </div>
        <a className="groupListItem__groupLink" href={this.props.group.url}>
          {this.props.group.name}
        </a>
        <div className="u-marginBottomTiny">
          <small>
            {groupInfoLine}
          </small>
        </div>
        {this.props.showDescription &&
          <p className="u-marginTopNone u-marginBottomNone">
            {this.props.group.description}
          </p>
        }
      </div>
    );
  }

  renderLastActiveTimestamp() {
    return (
      <span>
        Active
        {" "}
        <RelativeTime time={this.props.group.lastActiveAt} longFormat={true} />
      </span>
    );
  }
}

GroupListItem.defaultProps = {
  iconSize: ICON_SIZES.SMALL,
  showDescription: false,
  showMemberCount: false,
  showUnreadPosts: false,
};

GroupListItem.propTypes = {
  group: GrPropTypes.group().isRequired,
  iconSize: React.PropTypes.oneOf([ICON_SIZES.SMALL, ICON_SIZES.MEDIUM, ICON_SIZES.LARGE]),
  showDescription: React.PropTypes.bool,
  showMemberCount: React.PropTypes.bool,
  showUnreadPosts: React.PropTypes.bool,
};

export default GroupListItem;
